<template>
  <section class="content-header">
    <h1>Rentabilidad de operarios 2</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="operario">Operarios</label>
              <MultiSelect v-model="operariosSeleccionados" inputId="operario"
                :options="operarios" optionLabel="nombre" optionValue="id_operario"
                filter display="chip" :maxSelectedLabels="2"
                selectedItemsLabel="{0} operarios seleccionados"
                placeholder="Todos los operarios"
                scrollHeight="400px" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme('pdf')" :disabled="generando">
                <i class="fa" :class="generando === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                Generar PDF
              </button>
              <button class="btn btn-success" @click="cargarInforme('xls')" :disabled="generando">
                <i class="fa" :class="generando === 'xls' ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Generar Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { MultiSelect, Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '',
      operarios: [],
      operariosSeleccionados: [],
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    // El mapeo del case no cubre operario ni los dos botones,
    // así que montamos el POST directamente contra el formulario real
    async cargarInforme(tipo) {
      const destino = tipo === 'pdf' ? 'VentanaInforme' : 'iframeInforme';
      if (tipo === 'pdf') window.open('', 'VentanaInforme');

      this.generando = tipo;
      try {
        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.target = destino;
        form.action = 'https://' + direccion + '/rentabilidad_operarios2_pdf.php';

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        anyadir('companyia', this.companyia);
        anyadir('inicio', this.formatearFecha(this.fechaInicio));
        anyadir('final', this.formatearFecha(this.fechaFin));

        // Sin selección se manda un operario[] vacío, como el formulario original
        if (this.operariosSeleccionados.length) {
          this.operariosSeleccionados.forEach(id => anyadir('operario[]', id));
        } else {
          anyadir('operario[]', '');
        }

        // Solo viaja el botón pulsado
        if (tipo === 'pdf') {
          anyadir('Submit_pdf', 'Generar PDF');
        } else {
          anyadir('Submit_excel', 'Generar Excel');
        }

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/rentabilidad_operarios2');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      // Hay dos filtros con nombre_campo "id_operario" (operarios y proveedores);
      // el primero es el de operarios
      const fOperarios = filtros.filter(f => f.nombre_campo === 'id_operario')[0];

      this.companyias = fCompanyias ? fCompanyias.valores : [];
      this.companyia = '';

      // En el multiselect, no seleccionar nada ya significa "todos"
      this.operarios = fOperarios
        ? fOperarios.valores.filter(o => o.id_operario !== '')
        : [];
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-multiselect),
.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>